import { reduce } from 'lodash/fp';
import { createAction } from '@mews/framework';
import { getReservation, getReservationTimeUnitCount } from '../selectors';
import { BASKET_PRODUCT_COUNT_CHANGED } from './types';

export const addInitialReservationProductCounts =
    (reservationKey: $TSFixMe, scope: $TSFixMe, serviceId: $TSFixMe) => (dispatch: $TSFixMe, getState: $TSFixMe) => {
        const state = getState();

        // @ts-expect-error $TSFixMeError: Argument of type '{ reservationKey: any; scope: any; id: any; }' is not assignable to parameter of type '{ reservationKe...
        const timeUnitCount = getReservationTimeUnitCount(state, { reservationKey, scope, id: serviceId });
        // @ts-expect-error $TSFixMeError: Argument of type '{ reservationKey: any; scope: any; }' is not assignable to parameter of type '{ reservationKey: string...
        const { occupancyData, productIds } = getReservation(state, { reservationKey, scope });

        const unitCount = 1;
        const personCount = reduce((acc, c) => acc + c.personCount, 0, occupancyData);

        const productCounts = reduce(
            (acc, productId) => {
                // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
                acc[productId] = {
                    personCount,
                    unitCount,
                    timeUnitCount,
                };

                return acc;
            },
            {},
            productIds
        );

        const counts = {
            [reservationKey]: {
                ...productCounts,
            },
        };

        dispatch(createAction(BASKET_PRODUCT_COUNT_CHANGED, counts, { scope }));
    };
